// Shared media-query breakpoints for the submission flow.
//
// The 378px content column comes from the Figma desktop frame (5:2179), which
// is 1512px wide — so it is the right measurement up to about that size. Past
// it the column reads as a thin ribbon stranded in the middle of a very wide
// panel, so it steps up instead of staying pinned to the phone width.
//
// Steps rather than clamp()/vw for two reasons: the rendering is then identical
// in every browser the browserslist targets (">0.2%, not dead"), and the
// reference frame keeps the exact width the design specifies instead of a
// value interpolated near it.

export const DESKTOP = "1024px";
export const DESKTOP_WIDE = "1600px";
export const DESKTOP_XL = "1920px";
export const DESKTOP_XXL = "2560px";
